<div class="advanced-budget-allocation" [formGroup]="formArray.controls[group]" *ngIf="hasAnyInventoryLevelData">
  <acl-ngx-accordion title="ADVANCED (optional)" [open]="true">

    <!--Set Allocation By rule dropdown-->
    <div class="budget-distribution-dropdown-container">
      <label><strong>SET ALLOCATION RULE BY:</strong></label>
      <div class="budget-distribution-type-dropdown">
        <acl-ngx-select menuWidth="150px" [irreversible]="true" variant="static"
          (change)="onBudgetDistributionTypeChange($event)"
          [initialValue]="{'value': selectedBudgetDistributionType, 'label': budgetDistributionType[selectedBudgetDistributionType].label}">
          <ng-container *ngFor="let item of budgetDistributionType | keyvalue: returnZero">
            <acl-ngx-option [value]="item.value.key" [label]="item.value.label">
            </acl-ngx-option>
          </ng-container>
        </acl-ngx-select>
      </div>
    </div>

    <div class="error-list">
      <div *ngIf="minBudgetExceedsMaxBudget" class="text-danger">
        Min budget should not exceed Max budget value.
      </div>
      <div *ngIf="positiveIntegerBudgetRequired" class="text-danger">
        Budget value should be positive number
      </div>
      <div *ngIf="budgetValueShouldBeLessThanHundred" class="text-danger">
        Budget value should be less than or equal to 100
      </div>
    </div>

    <!--Budget Allocation Content-->
    <div class="advance-bugdet-allocation-content">
      <div class="inv-src-data-table">
        <div class="list-section">
          <div class="table-section">
            <table class="table table-bordered" *ngIf="budgetDistributionTypeControl.value">
              <!--table headers-->
              <thead>
                <tr>
                  <th class="accordion-icon-col"></th>
                  <th class="name-col" scope="col">Name</th>
                  <th scope="col">Deal ID</th>
                  <th class="text-right" scope="col">Allocated</th>
                  <th class="text-right" scope="col">Min Budget</th>
                  <th class="text-right" scope="col">Max Budget</th>
                </tr>
              </thead>
              <tbody>
                <!--Inventory Source Totals-->
                <ng-container>
                  <tr class="dark-header">
                    <td [attr.colspan]="2" class="border-0">Inventory Source Totals</td>
                    <!-- <td class="border-0"></td> -->
                    <td class="border-0"></td>
                    <td class="border-0 text-right"></td>
                    <td class="border-0 text-right">{{minValueTotal}}</td>
                    <td class="border-0 text-right">{{maxValueTotal}}</td>
                  </tr>
                </ng-container>
                <!--Open Auctions-->
                <ng-container>
                  <!--Open Auctions Totals-->
                  <tr class="collapsed totals-row" data-toggle="collapse" data-target="#exchanges"
                    (click)="showExchanges = !showExchanges">
                    <td class="contain-col-content  accordion-icon border-right-0">
                      <acl-ngx-icon name="TriangleRight" size="12" *ngIf="showExchanges">
                      </acl-ngx-icon>
                      <acl-ngx-icon name="TriangleDown" size="12" *ngIf="!showExchanges">
                      </acl-ngx-icon>
                    </td>
                    <td class="border-left-0">Open Auctions</td>
                    <td class="contain-col-content"></td>
                    <td class="contain-col-content text-right"></td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                  </tr>
                  <!--Open Exchanges Results-->
                  <ng-container *ngIf="openAuctionData">
                    <tr *ngFor="let item of openAuctionData; let i=index" [ngbCollapse]="showExchanges" id="exchanges"
                      class="collapse">
                      <td class="border-right-0"></td>
                      <td class="contain-col-content border-left-0" [title]="item.label">{{item.label}}</td>
                      <td class="contain-col-content"> - </td>
                      <td class="text-right"> {{ item.allocated }} </td>
                      <td class="text-right">
                        <acl-ngx-input placeholder="Enter" [ngModelOptions]="{standalone: true}" type="number"
                          [(ngModel)]="item.value[0]"
                          (onBlur)="onMinMaxValueChange({value: $event.target.value, index: i, type: 'openAuctionData', accessor: 0})">
                        </acl-ngx-input>
                      </td>
                      <td class="text-right">
                        <acl-ngx-input placeholder="Enter" [ngModelOptions]="{standalone: true}" type="number"
                          [(ngModel)]="item.value[1]"
                          (onBlur)="onMinMaxValueChange({value: $event.target.value, index: i, type: 'openAuctionData', accessor: 1})">
                        </acl-ngx-input>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
                <!--Private Deals-->
                <ng-container>
                  <!--Private Deals Totals-->
                  <tr class="collapsed totals-row" data-toggle="collapse" data-target="#privateDeals"
                    (click)="showPrivateDeals = !showPrivateDeals">
                    <td class="contain-col-content border-right-0">
                      <acl-ngx-icon name="TriangleRight" size="12" *ngIf="showPrivateDeals">
                      </acl-ngx-icon>
                      <acl-ngx-icon name="TriangleDown" size="12" *ngIf="!showPrivateDeals">
                      </acl-ngx-icon>
                    </td>
                    <td class="border-left-0">Private Deals</td>
                    <td class="contain-col-content"></td>
                    <td class="contain-col-content text-right"></td>
                    <td class="text-right"></td>
                    <td class="text-right"></td>
                  </tr>
                  <!--Private deal Results-->
                  <ng-container *ngIf="privateDealsData">
                    <ng-container *ngFor="let item of privateDealsData; let i = index">
                      <tr data-toggle="collapse" [ngbCollapse]="showPrivateDeals" id="privateDeals" class="collapse"
                        data-target="#deals">
                        <td class="contain-col-content border-right-0"></td>
                        <td class="border-left-0 cursor-pointer" (click)="item.isCollapsed = !item.isCollapsed">
                          <span class="sub-accordion">
                            <acl-ngx-icon name="TriangleRight" size="12" *ngIf="item.isCollapsed">
                            </acl-ngx-icon>
                            <acl-ngx-icon name="TriangleDown" size="12" *ngIf="!item.isCollapsed">
                            </acl-ngx-icon>
                          </span>
                          <span [title]="item.label">{{item.label}}</span>
                        </td>
                        <td class="contain-col-content"></td>
                        <td class="contain-col-content text-right">{{item.allocated}}</td>
                        <td class="text-right">
                          <acl-ngx-input placeholder="Enter" type="number" [(ngModel)]="item.value[0]"
                            [ngModelOptions]="{standalone: true}"
                            (onBlur)="onMinMaxValueChange({value: $event.target.value, index: i, type: 'privateDealsData', accessor: 0})">
                          </acl-ngx-input>
                        </td>
                        <td class="text-right">
                          <acl-ngx-input placeholder="Enter" type="number" [(ngModel)]="item.value[1]"
                            [ngModelOptions]="{standalone: true}"
                            (onBlur)="onMinMaxValueChange({value: $event.target.value, index: i, type: 'privateDealsData', accessor: 1})">
                          </acl-ngx-input>
                        </td>
                      </tr>
                      <ng-container>
                        <tr *ngFor="let j of item.deals" class="collapse"
                          [ngbCollapse]="item.isCollapsed || showPrivateDeals" id="privateDeals" class="collapse">
                          <td class="border-right-0"></td>
                          <td class="contain-col-content p-left-35 border-left-0" [title]="j.name">
                            <span>{{j.name}}</span>
                            <span *ngIf="j.amobeePreferred" class="amobee-preferred-info-icon margin-left-15">
                              <acl-ngx-icon name="Info" title="This is an Amobee Preferred Deal" size="16">
                              </acl-ngx-icon>
                            </span>
                          </td>
                          <td class="contain-col-content" [title]="j.dealId">{{j.dealId}}</td>
                          <td class="text-right"> </td>
                          <td class="text-right"> - </td>
                          <td class="text-right"> - </td>
                        </tr>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <!--Guaranteed Deals-->
                <!-- <ng-container> -->
                <!--Guaranteed Deals Totals-->
                <!-- <tr class="collapsed totals-row" data-toggle="collapse" data-target="#guaranteedDeals"
                    (click)="guaranteedDeals = !guaranteedDeals">
                    <td class="contain-col-content border-right-0">
                      <acl-ngx-icon name="TriangleRight" size="12" *ngIf="guaranteedDeals">
                      </acl-ngx-icon>
                      <acl-ngx-icon name="TriangleDown" size="12" *ngIf="!guaranteedDeals">
                      </acl-ngx-icon>
                    </td>
                    <td class="border-left-0">Guaranteed Deals</td>
                    <td class="contain-col-content"> - </td>
                    <td class="contain-col-content">104256</td>
                    <td>
                      $
                    </td>
                    <td>
                      -
                    </td>
                  </tr> -->
                <!--Gauranteed Deals Results-->
                <!-- <ng-container *ngIf="pgDealData">
                    <tr *ngFor="let item of pgDealData" [ngbCollapse]="guaranteedDeals" id="guaranteedDeals"
                      class="collapse">
                      <td class="border-right-0"></td>
                      <td class="contain-col-content border-left-0">Deal -1</td>
                      <td class="contain-col-content">12321</td>
                      <td>
                        -
                      </td>
                      <td>
                        <acl-ngx-input placeholder="Enter"></acl-ngx-input>
                      </td>
                      <td>
                        <acl-ngx-input placeholder="Enter"></acl-ngx-input>
                      </td>
                    </tr>
                  </ng-container> -->
                <!-- </ng-container> -->
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </acl-ngx-accordion>
</div>
